module.exports = __webpack_public_path__ + "img/pattern-bg.bd6eaef7.jpg";